<template>
  <chart-wrapper :class="slotClass">
    <el-icon v-if="setting" class="edit-btn" size="18" @click="$emit('edit')"><Edit /></el-icon>
    <div class="chart-content">
      <component :is="widget" :ref="setRef" v-bind="widgetProps" />
    </div>
  </chart-wrapper>
</template>

<script setup>
import { computed } from 'vue'
import { getWidgetComponent } from '../config/kpiRegistry'
import ChartWrapper from './ChartWrapper.vue'

const props = defineProps({
  slotClass: String,
  kpiId: Number,
  rawData: null,
  setting: Boolean,
  formatWidgetProps: Function,
  setSlotRef: Function,
  slotKey: String
})

defineEmits(['edit'])

const widget = computed(() => getWidgetComponent(props.kpiId))
const widgetProps = computed(() => props.formatWidgetProps(props.kpiId, props.rawData))
const setRef = (el) => props.setSlotRef(props.slotKey, el)
</script>

<style lang="scss" scoped>
.chart-content {
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.2);
}
.edit-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 99;
  color: var(--my-text-color);
}
</style>
